import AnswerBlock, { type AnswerBlockProps } from '@/components/chat/AnswerBlock';
import { FormGroup } from '@/components/FormGroup';

import Fields from './Fields';

export type AnswerRequestProps = {
  data: Omit<AnswerBlockProps, 'type'> & {
    type: 'single' | 'multiple' | 'text';
  };
};

const AnswerRequest = ({ data }: AnswerRequestProps) => {
  if (data.type === 'text') {
    return (
      <FormGroup collapsable={false} showValidationState={false} reviewMode={false} allowEdit={false}>
        <Fields awaitOnAnswer={data.awaitOnAnswer} />
      </FormGroup>
    );
  }

  return <AnswerBlock {...data} type={data.type} />;
};

export default AnswerRequest;
